(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-provider-games/assets/javascripts/page-provider-games.js') >= 0) return;  svs.modules.push('/components/casino-react/page-provider-games/assets/javascripts/page-provider-games.js');
"use strict";


const {
  useParams
} = ReactRouterDOM;
const {
  useMemo,
  useEffect
} = React;
const {
  GridDisplayModes
} = svs.components.casino_react.common.constants;
const {
  CasinoSection
} = svs.components.casino_react.casinoSection;
const {
  FilterAndSort
} = svs.components.casino_react.filterAndSort;
const {
  cmsProviderList
} = svs.casino_react.shared.data;
const {
  useGetSearchResultQuery
} = svs.components.casino_react.casinoStore.endpoints.searchApi;
const {
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  SubHeader
} = svs.components.casino_react.sub_header;
const {
  setMetaTags
} = svs.components.lbUtils.setMetaTags;
const actionButtons = () => React.createElement(FilterAndSort, {
  includeProviderFilters: false
});
const useGetProviderGames = _ref => {
  let {
    provider,
    shouldSkipFetch
  } = _ref;
  const {
    tags,
    categories,
    sorting
  } = useSearchParams();
  const {
    data,
    isLoading,
    error,
    isFetching,
    totalCount
  } = useGetSearchResultQuery({
    providers: [provider],
    categories,
    tags,
    sorting
  }, {
    skip: shouldSkipFetch,
    selectFromResult: result => {
      if (shouldSkipFetch || !(result !== null && result !== void 0 && result.data)) {
        return {
          data: {
            games: null,
            error: null,
            totalCount: null
          }
        };
      }
      return result;
    }
  });
  return {
    data,
    isLoading,
    error,
    isFetching,
    totalCount
  };
};
const PageProviderGames = () => {
  const {
    providerName
  } = useParams();
  const provider = useMemo(() => cmsProviderList.find(provider => provider.model.systemName === providerName), [providerName]);
  const shouldSkipFetch = !provider;
  const {
    data,
    isLoading,
    isFetching,
    error
  } = useGetProviderGames({
    provider: provider === null || provider === void 0 ? void 0 : provider.model.provider,
    shouldSkipFetch
  });
  useEffect(() => {
    if (provider !== null && provider !== void 0 && provider.model.provider) {
      setMetaTags({
        docTitle: "Spel fr\xE5n ".concat(provider.model.provider, " | ").concat(svs.casino_react.shared.data.seo.productName, " | Svenska Spel")
      });
    }
  }, [provider === null || provider === void 0 ? void 0 : provider.model.provider]);
  if (!provider) {
    return React.createElement("p", {
      className: "align-center margin-top-4"
    }, "Vi hittade inga resultat f\xF6r leverant\xF6r:", ' ', React.createElement("span", {
      className: "f-italic bold"
    }, providerName));
  }
  return React.createElement(React.Fragment, null, React.createElement(SubHeader, {
    title: "Spel fr\xE5n ".concat(provider.model.provider)
  }), React.createElement("div", {
    className: "page-provider-games"
  }, React.createElement(CasinoSection, {
    ActionButtons: actionButtons,
    displayMode: GridDisplayModes.GRID_UNRESTRICTED,
    isSearchResult: Boolean(!isFetching && !isLoading && !error && (data === null || data === void 0 ? void 0 : data.games)),
    items: !isLoading && !error && data !== null && data !== void 0 && data.games ? data.games : [],
    title: data !== null && data !== void 0 && data.totalCount ? "".concat(data === null || data === void 0 ? void 0 : data.totalCount, " spel") : ''
  })));
};
setGlobal('svs.components.casino_react.pageProviderGames.PageProviderGames', PageProviderGames);

 })(window);